import { Route, Switch } from "react-router-dom";
import EditCascadingVariable from "./edit.cascadingVariable";
import EditProofing from "./edit.rule";
import ViewProofing from "./view";

const Proofing = () => {
    return (
        <Switch>
            <Route exact path='/admin/proofing' component={ViewProofing} />
            <Route exact path='/admin/proofing/:id' component={EditProofing} />
            <Route exact path='/admin/proofing/var/:id' component={EditCascadingVariable} />
        </Switch>
    )
}

export default Proofing;